var map = {
	"./中国田园风2.png": 2110,
	"./中国田园风3.png": 7686,
	"./中国田园风4.png": 4502,
	"./中国田园风5.png": 8763,
	"./中国风1.png": 6135,
	"./中式克苏鲁1.png": 6759,
	"./中式克苏鲁2.png": 2767,
	"./中式克苏鲁3.png": 640,
	"./中式克苏鲁4.png": 2669,
	"./中式克苏鲁5.png": 678,
	"./中式克苏鲁6.png": 2759,
	"./中式克苏鲁7.png": 7415,
	"./中式田园风1.png": 8631,
	"./仙侠1.png": 8922,
	"./仙侠2.png": 4986,
	"./仙侠3.png": 2825,
	"./仙侠4.png": 9051,
	"./仙侠5.png": 7698,
	"./仙侠6.png": 8290,
	"./废土1.png": 3767,
	"./志怪1.png": 8357,
	"./志怪2.png": 9199,
	"./志怪3.png": 1220,
	"./志怪4.png": 5484,
	"./志怪5.png": 589,
	"./志怪6.png": 5721,
	"./武侠1.png": 7425,
	"./武侠2.png": 432,
	"./武侠4.png": 7780,
	"./武侠5.png": 9702,
	"./武侠6.png": 6943,
	"./武侠7.png": 2569,
	"./武侠8.png": 8568,
	"./民俗1.png": 9923,
	"./民俗2.png": 6403,
	"./民俗3.png": 6894,
	"./民俗4.png": 6653,
	"./民俗5.png": 4951,
	"./民俗6.png": 6205,
	"./西幻.png": 7959,
	"./西幻2.png": 6331,
	"./西幻3.png": 5036,
	"./西幻4.png": 6096,
	"./西幻5.png": 4126,
	"./赛博朋克.png": 3075,
	"./赛博朋克1.png": 2518
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9680;